import {
    Component,
    Input,
    Output,
    EventEmitter,
    forwardRef,
    ViewEncapsulation,
    ElementRef,
    OnInit,
} from '@angular/core';

import { NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnInputValueAccessor } from '../../core';
import { isNotNull } from '../../util/check';

@Component({
    selector: 'fn-tel-input',
    templateUrl: 'fn-tel-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FnTelInputComponent),
            multi: true,
        },
    ],
    encapsulation: ViewEncapsulation.None,
})
export class FnTelInputComponent
    extends FnInputValueAccessor<any>
    implements OnInit {
    constructor(private elementRef: ElementRef) {
        super();
    }

    isValid = false;

    @Input() name = '';

    @Input() id = '';

    @Input() placeholder = '';

    @Input() countryCode = 'us';

    @Input() isErrorBox = true;

    @Input() isRequired = false;

    @Input() customClass: string;

    @Input() tabIndex = 0;

    @Input() parentForm: NgForm;

    @Input() fnTelInputOptions: { [key: string]: any } = {};

    @Input() fieldConfig: any;

    @Output() getTelNumber = new EventEmitter();

    @Output() isValidNumber = new EventEmitter();

    @Output() telInputObject = new EventEmitter();

    @Output() changeCountry = new EventEmitter();

    ngOnInit(): void {
        this.fnTelInputOptions['initialCountry']=this.countryCode;
    }

    hasError(isValidNum: boolean) {
        if (this.parentForm) {
            if (this.isNotEmptyNumber() && !isValidNum) {
                this.parentForm.controls[this.name].setErrors({ valid: false, message: 'Invalid_' + this.name });
            } else {
                this.parentForm.controls[this.name].setErrors(null);
            }
        }
        this.isValid = isValidNum;
        this.isValidNumber.emit(isValidNum);
    }

    isNotEmptyNumber() {
        return isNotNull(this.value) && (this.value + '').trim() !== '';
    }
}
